module.exports = __webpack_public_path__ + "img/KZT.1e49152f.svg";